import { useEffect } from "react";

const DEFAULT_TITLE = "Vowpin Global — Digital Gift Card Distribution & Reward Solutions";
const DEFAULT_DESC =
  "Vowpin Global — premium digital gift card distribution & reward solutions. 500+ global brands, 120+ countries, instant delivery.";

export function useSEO(title = DEFAULT_TITLE, description = DEFAULT_DESC) {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    const prev = meta?.getAttribute("content");
    if (meta) meta.setAttribute("content", description);
    return () => {
      document.title = DEFAULT_TITLE;
      if (meta && prev) meta.setAttribute("content", prev);
    };
  }, [title, description]);
}
